import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { APP_HERO_PRODUCTS } from '@white-label-configuration/constants';
import ProductTags from '../product-tags/product-tags.vue';

type Props = {
  product: any;
  productName?: string;
  airportName?: string;
  orderId?: string;
  hideOrderId?: boolean;
  hideOrderIdItem?: boolean;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'b-ticket-header',
  props: {
    product: null,
    productName: { default: '' },
    airportName: { default: '' },
    orderId: { default: '' },
    hideOrderId: { type: Boolean, default: false },
    hideOrderIdItem: { type: Boolean, default: false }
  },
  emits: ["click"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'click'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { product: any, productName: string, airportName: string, orderId: string, hideOrderId: boolean, hideOrderIdItem: boolean };





const isFasttrackProduct = computed(() => {
  return (
    props.product.product_code === APP_HERO_PRODUCTS.FASTTRACK ||
    props.product.productHeader?.product_code === APP_HERO_PRODUCTS.FASTTRACK
  );
});

const isTravelInsuranceProduct = computed(() => {
  return props.product.product_code === APP_HERO_PRODUCTS.TRAVEL_INSURANCE;
});

return { __sfc: true,props, emit, isFasttrackProduct, isTravelInsuranceProduct, ProductTags }
}

})